import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_60: FaireProductEntity = {
  token: "catalog_prod_prod-60",
  type: "product",
  name: "Woven Rattan Storage Basket - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=400&fit=crop",
  priceDollars: 36.04,
  msrpDollars: 90.1,
  sku: "JA0060",
  caseSize: 4,
  material: "Metal",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 232,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_gift-wrapping"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
